// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADD_REVIEW_FOR_STROLLER_SALE_FASTER = "rychleji prod\u00e1vaj\u00ed";
export const ADD_REVIEW_FOR_STROLLER_TO_BOOST_SALE_stroller_boost = "P\u0159idej hodnocen\u00ed ko\u010d\u00e1rku %(stroller)s. Ko\u010d\u00e1rky s hodnocen\u00edm se %(boost)s. Nav\u00edc pom\u016f\u017ee\u0161 ostatn\u00edm mamink\u00e1m ve v\u00fdb\u011bru.";
export const STROLLER_ADD_REVIEW = "P\u0159idej hodnocen\u00ed";
export const STROLLER_BRAND = "Zna\u010dka";
export const STROLLER_INFO_MORE_ABOUT_model = "V\u00edce o %(model)s v Ko\u010d\u00e1rkop\u00e9dii";
export const STROLLER_INFO_SHOW_REVIEWS = "Zobrazit hodnocen\u00ed";
